import React from "react";

export const UiPinkCard = (props) => {
  return (
    <>
      <div
        className="df-pink-card"
        style={{ backgroundImage: `url(${props.bgImgUrl})` }}
      >
        <div className={props.className}>{props.children}</div>
      </div>
    </>
  );
};
